module.exports = __webpack_public_path__ + "static/adidas-01690c2aa003b751f2d066b7194f7bfa.svg";